import { PlanTasksArchIcon } from '@infotech/uikit-icons'
import { SERVICES_SCHEMA_NAME } from '../api/services'

export default {
  id  : `services`,
  name: `Сервисы`,
  to  : `/${SERVICES_SCHEMA_NAME}`,
  icon: PlanTasksArchIcon,
}
